import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import UnfinishedDPN from './UnfinishedDPN';
import { loadDOMComponent } from '../../../../../helpers';
import { store } from '../../../../../store/store';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { NCZICommandContextProvider } from '../../../Services/NCZICommandContext';
import AclContextProvider from '../../../../Acl/Components/AclContextProvider';

loadDOMComponent({
  selector: 'react-nczi-edpn-list',
  // @ts-ignore: TODO: needs typings
  callback: ({ container, context, props }) => {
    const userId = container.getAttribute('userId');

    ReactDOM.render(
      <Provider store={store}>
        <AppContextProvider {...context}>
          <AclContextProvider>
            <NCZICommandContextProvider>
              <UnfinishedDPN userId={userId} />
            </NCZICommandContextProvider>
          </AclContextProvider>
        </AppContextProvider>
      </Provider>,
      container,
    );
  },
});
